import script from "./SubirManualView.vue?vue&type=script&setup=true&lang=js"
export * from "./SubirManualView.vue?vue&type=script&setup=true&lang=js"

import "./SubirManualView.vue?vue&type=style&index=0&id=00fa4c76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00fa4c76"]])

export default __exports__